import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BranchDetail } from './../../interfaces/branch';
import { DataMappingService } from './../../services/data-mapping.service';
import { JsonDataService } from './../../services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { UserDetail } from './../../interfaces/user';

@Component({
  selector: 'app-user-signup',
  templateUrl: './user-signup.component.html',
  styleUrls: ['./user-signup.component.scss']
})
export class UserSignupComponent implements OnInit {
  // selectedUser = {} as UserDetail;
  public userSignupForm: FormGroup;
  isLoading = false;
  isNew = false;
  userSignupData = new FormData();
  isSigningUpUser = false;
  public onClose= new Subject<boolean>();
  isBranchesLoaded = false;
  branchesList = [] as BranchDetail[];
  selectedBranch = {} as BranchDetail;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {

    this.userSignupForm = this.formBuilder.group({
      branch: ['', [Validators.required]],
      username: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.getBranches();

    console.log(`UserSignupComponent, ngOnInit, This is user signup modal`);
    console.log(`UserSignupComponent, ngOnInit, isNew: ${this.isNew}`);
    // if (!this.isNew) {
    //   console.log(`UserSignupComponent, selectedUser: ${JSON.stringify(this.selectedUser)}`);
    //   this.selectedBranch = this.selectedUser.branch
    //   this.patchUserSignupForm(this.selectedUser);
    // }

    this.setFormFieldsSelectedValue();
  }

  setFormFieldsSelectedValue() {
    this.userSignupForm.get('branch')?.valueChanges.subscribe(value => {
      console.log(`branch chang, value: ${JSON.stringify(value)}`);
      this.selectedBranch = value;
      console.log(`userSignupForm chang, value: ${value}, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    });
  }

  getBranches() {
    this.isBranchesLoaded = false;
    this.petService.getBranches().subscribe({
      next: (response) => {
        console.log(`getBranches, response: ${JSON.stringify(response)}`);
        this.branchesList = response;
        this.selectedBranch = this.branchesList[0];

        // if (!this.isNew) {
        //   console.log(`getBranches, Not new`);
        //   this.selectedBranch = this.branchesList.filter(b => b.id==this.selectedUser.branch.id)[0];
        // }

        console.log(`getBranches, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
        this.userSignupForm.get('branch')?.setValue(this.selectedBranch);
        this.isBranchesLoaded = true;
      },
      error: (error) => {
        this.isBranchesLoaded = true;
        console.error(`getBranches, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getBranches

  // patchUserSignupForm(user: UserDetail) {
  //   this.userSignupForm.patchValue(user);
  //   this.userSignupForm.controls['branch'].setValue(user.branch.name);
  // } // end of patchUserSignupForm

  // signupUser() {
  //   console.log(`signupUser, isNew:${this.isNew}`);

  //   // if(!this.isNew) {
  //   //   this.updateUser();
  //   // } else {
  //   //   this.createUser();
  //   // }
  // } // end of saveUser

  createUser() {
    this.isSigningUpUser = true;
    this.generateCreateUserPayload();
    console.log(`createUser, user data:${JSON.stringify(this.userSignupData)}`);
    this.petService.createUser(this.userSignupData).subscribe({
      next: (response) => {
        this.isSigningUpUser = false;
        console.log(`createUser, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
      },
      error: (error) => {
        this.isSigningUpUser = false;
        console.error(`createUser, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSigningUpUser = false;
  } // end of createUser

  // saveUser() {
  //   console.log(`saveUser, isNew:${this.isNew}`);

  //   // if(!this.isNew) {
  //   //   this.updateUser();
  //   // } else {
  //   //   this.createUser();
  //   // }
  // } // end of saveUser



  // updateUser() {
  //   this.isSavingUser = true;
  //   this.createUserUpdatePayload();
  //   console.log(`updateUser, userUpdateData:${this.userUpdateData}`);
  //   this.petService.updateUser(this.selectedUser.id, this.userUpdateData).subscribe({
  //     next: (response) => {
  //       this.isSavingUser = false;
  //       console.log(`updateUser, response: ${JSON.stringify(response)}`);
  //       this.hideModal(true);
  //       this.router.navigate(['user']);
  //     },
  //     error: (error) => {
  //       this.isSavingUser = false;
  //       console.error(`updateUser, error: ${JSON.stringify(error)}`);
  //     }
  //   });
  //   this.isSavingUser = false;
  // } // end of updateUser

  // createUser() {
  //   this.isSavingUser = true;
  //   this.createUserUpdatePayload();
  //   console.log(`createUser, user data:${JSON.stringify(this.userUpdateData)}`);
  //   this.petService.createUser(this.userUpdateData).subscribe({
  //     next: (response) => {
  //       this.isSavingUser = false;
  //       console.log(`createUser, response: ${JSON.stringify(response)}`);
  //       this.hideModal(true);
  //     },
  //     error: (error) => {
  //       this.isSavingUser = false;
  //       console.error(`createUser, error: ${JSON.stringify(error)}`);
  //     }
  //   });
  //   this.isSavingUser = false;
  // } // end of createUser

  generateCreateUserPayload() {
    const formValues = this.userSignupForm.value;

    this.userSignupData.append('username', formValues.username);
    this.userSignupData.append('first_name', formValues.firstName);
    this.userSignupData.append('last_name', formValues.lastName);
    this.userSignupData.append('email', formValues.email);
    this.userSignupData.append("branch_id", this.selectedBranch.id);
    this.userSignupData.append("password", formValues.password);
    this.userSignupData.append("confirm_password", formValues.confirmPassword);
  }  // end of generateCreateUserPayload

  closeModal(result: boolean) {
    this.hideModal(result);
  } // end of closeModal

  hideModal(result: boolean) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal

  // Custom validator function to check if passwords match
  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { mismatch: true };
  }
}
